module.exports = __webpack_public_path__ + "static/media/react-logo-transparent.0b19e7b6.svg";